import React from 'react';
import PropTypes from 'prop-types';
import { FluidImage, SquareImageContainer } from '@vp/swan';

const FixedRatioImage = ({
  src,
  srcSet = undefined,
  containerProps = {},
  alt = '',
  ...rest
}) => (
  /* eslint-disable react/jsx-props-no-spreading */
  <SquareImageContainer style={{ textAlign: 'center' }} {...containerProps}>
    <FluidImage src={src} srcSet={srcSet} alt={alt} {...rest} />
  </SquareImageContainer>
  /* eslint-enable react/jsx-props-no-spreading */
);

FixedRatioImage.propTypes = {
  src: PropTypes.string,
  srcSet: PropTypes.arrayOf(PropTypes.string),
  // Need to determine propTypes for React UI lib components since there can be a lot of them
  containerProps: PropTypes.object,
  alt: PropTypes.string,
};

export default FixedRatioImage;
